import React from 'react';

export default function MagicWand() {
	// 9
	let style = {
		st89: {
 			opacity:0.2,
			fill:"#FFEAAE"
		},
		st19: {
 			fill:"#75C69F"
		},
		st36: {
 			fill:"#987FEF"
		},
		st29: {
 			fill:"#5994C9"
		},
		st67: {
 			fill:"#F9914B"
		},
		st70: {
 			fill:"#FFEAAE"
		},
		st72: {
 			fill:"#F79AC0"
		},
		st0: {
 			fill:"#FFFFFF"
		}
	};
	return (
		<g>
			<circle style={style.st89} cx="62.5" cy="284.8648071" r="58.9804611"/>
			<polygon style={style.st19} points="69.3496246,308.1174927 68.0444336,305.6479492 76.8852539,300.9750977 82.3833466,311.3780212
				"/>
			<polygon style={style.st36} points="101.3212128,368.6108093 97.0195618,360.4716492 110.0566711,363.7385559 114.3559952,371.873291
				"/>
			<line style={style.st29} x1="106.2882309" y1="356.6083069" x2="110.0566711" y2="363.7385559"/>
			<polygon style={style.st19} points="93.2526474,353.3442688 89.2551346,345.7806091 102.2740173,349.013031 106.2882309,356.6083069
				"/>
			<line style={style.st29} x1="98.5195999" y1="341.9093323" x2="102.2740173" y2="349.013031"/>
			<polygon style={style.st67} points="94.221817,333.7774963 98.5195999,341.9093323 85.4901047,338.6568298 81.1843948,330.5100098 	"/>
			<line style={style.st29} x1="90.4523773" y1="326.6453857" x2="94.221817" y2="333.7774963"/>
			<polygon style={style.st36} points="73.1164856,315.244751 77.4168396,323.3814392 90.4523773,326.6453857 86.1519089,318.5084839 	"/>
			<line style={style.st29} x1="82.3833466" y1="311.3780212" x2="86.1519089" y2="318.5084839"/>
			<polygon style={style.st29} points="73.1171265,315.2459717 86.151062,318.5068359 82.3843384,311.3798828 69.3504028,308.1188965 	"/>
			<path style={style.st70} d="M65.3790817,264.8403015l18.1977386-6.5726624c3.0600739-1.1052246,6.0591507,1.7781982,5.075058,4.879364
				l-5.8522644,18.4420166l11.8743668,15.2760315c1.9967575,2.5687561,0.181221,6.3120728-3.0722504,6.3344421l-19.3478622,0.1330872
				l-10.8589745,16.0137329c-1.8260078,2.6928101-5.947155,2.1228943-6.9738121-0.9644165l-6.1053734-18.3598022
				l-18.5855827-5.3789673c-3.1252899-0.9045105-3.8567638-5.0000916-1.2378025-6.9305115l15.5745296-11.4800415
				l-0.6275444-19.3381348c-0.105526-3.2518463,3.5635452-5.2131195,6.2088089-3.3188782L65.3790817,264.8403015z"/>
			<polygon style={style.st72} points="90.4534302,326.6473389 77.4194946,323.3864746 81.1862183,330.5134277 94.2201538,333.774292 	"/>
			<polygon style={style.st70} points="98.522522,341.9147949 85.4885864,338.6539307 89.2553101,345.7808838 102.2685547,349.0366211
				102.274292,349.0136719 	"/>
			<polygon style={style.st29} points="106.2868652,356.6057129 93.2529297,353.3447266 97.0195923,360.4716797 110.0535278,363.732666
				"/>
			<path style={style.st72} d="M115.9458008,374.8813477l-1.5899048-3.0081787l-13.0338745-3.2608643l3.3010178,6.2459106
				c0,0,1.7102966,2.0106506,6.2098389,2.0106506C114.5833359,376.868866,115.9458008,374.8813477,115.9458008,374.8813477z"/>
			<path style={style.st70} d="M65.3790817,264.8403015l18.1977386-6.5726624c3.0600739-1.1052246,6.0591507,1.7781982,5.075058,4.879364
				l-5.8522644,18.4420166l11.8743668,15.2760315c1.9967575,2.5687561,0.181221,6.3120728-3.0722504,6.3344421l-19.3478622,0.1330872
				l-10.8589745,16.0137329c-1.8260078,2.6928101-5.947155,2.1228943-6.9738121-0.9644165l-6.1053734-18.3598022
				l-18.5855827-5.3789673c-3.1252899-0.9045105-3.8567638-5.0000916-1.2378025-6.9305115l15.5745296-11.4800415
				l-0.6275444-19.3381348c-0.105526-3.2518463,3.5635452-5.2131195,6.2088089-3.3188782L65.3790817,264.8403015z"/>
			<path style={style.st0} d="M56.1459961,291.8779297l-8.2877388-2.3987732c-1.4418488-0.4172974-1.7793121-2.3067932-0.571064-3.1974182
				l6.9447403-5.1191406l-0.2795372-8.6228638c-0.0486374-1.5002747,1.6441574-2.4050598,2.8645439-1.5310974l7.0141144,5.0231018
				l8.1151047-2.9311523c1.4117737-0.5099182,2.7954483,0.820343,2.3414612,2.2510986l-2.6093979,8.2235107l5.2948532,6.8121033
				c0.9211884,1.1851807,0.0834961,2.9121704-1.4175339,2.9224243l-8.6273193,0.0589294l-4.8423576,7.1410522
				c-0.8424416,1.2423706-2.7437744,0.9794312-3.2174301-0.4449463L56.1459961,291.8779297z"/>
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Toy/MagicWand.js